import { cn } from "@omni/utils/styles";

import { FormGroup } from "@/components/Form/Base/formGroup.component";
import { Input } from "@/components/Form/Base/input.component";
import { Label } from "@/components/Form/Base/label.component";

import ResultField, {
    ResultFieldProps
} from "../ResultField/resultField.component";

type CheckBoxResultFieldProps = ResultFieldProps & {
    onCheck: () => void;
    isChecked: boolean;
    isDependent?: boolean;
};

const CheckBoxResultField = ({
    copy,
    copyPostfix,
    value,
    unit,
    sup,
    sm,
    md,
    lg,
    onCheck,
    isChecked,
    isDependent
}: CheckBoxResultFieldProps) => {
    return (
        <ResultField
            copy={copy}
            copyPostfix={copyPostfix}
            value={value}
            unit={unit}
            sup={sup}
            sm={sm}
            md={md}
            lg={lg}
        >
            <FormGroup toggle={true}>
                <Label
                    className={cn("tw:pr-2", {
                        "tw:pl-6": !!isDependent
                    })}
                >
                    <Input
                        type="checkbox"
                        checked={isChecked}
                        onChange={onCheck}
                        className={cn("tw:m-0 tw:relative tw:p-0")}
                    />
                </Label>
            </FormGroup>
        </ResultField>
    );
};

export default CheckBoxResultField;
